export default "/img/KR.c146cdf9f6807edc095553d5d733fb49.png";